import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Map, InfoWindow, Marker, GoogleApiWrapper, OverlayView } from 'google-maps-react';
import PinIcon from "../../common/images-new/pin-icon.svg"

const containerStyle = {
    position: 'relative',
    height: '302px'
}


function MapGoogleAnalytics(data) {
    const [activeMarker, setActiveMarker] = useState({});
    const [selectedPlace, setSelectedPlace] = useState({});
    const [showingInfoWindow, setShowingInfoWindow] = useState(false);
    const centerPoint = { lat: 1.372082067940902, lng: 103.87135304140541 }

    const [google, setGoogle] = useState(null);
    const [locations, setLocations] = useState(data?.locations?.data || []);

    const onMarkerClick = (props, marker, e) => {
        setSelectedPlace(props)
        setActiveMarker(marker)
        setShowingInfoWindow(true)
    }

    const onInfoWindowClose = () => {
        setActiveMarker(null)
        setShowingInfoWindow(false)
    };
    const locationsdata = useSelector(state => state.showcase.locations)

    return (
        <Map
            containerStyle={containerStyle}
            google={window.google}
            zoom={10}
            initialCenter={centerPoint}
        >
            {
                locations &&
                locations?.map((marker, index) => (
                    <Marker
                        onClick={onMarkerClick}
                        key={index}
                        icon={{
                            url: PinIcon,
                            anchor: new window.google.maps.Point(32, 32),
                            scaledSize: new window.google.maps.Size(32, 32)
                        }}
                        currentlat={marker?.reflection_latitude + "_" + marker?.reflection_longitude}
                        position={{ lat: marker?.reflection_latitude, lng: marker?.reflection_longitude }}
                        title={marker?.reflection_title}
                        postId={marker?.reflection_id}
                    />
                )
                )}
        </Map>

    )

}

export default GoogleApiWrapper({
    apiKey: ('AIzaSyDXgsxWEgtVWgZdU5W4htOoQgUOOVeYK1k')
})(MapGoogleAnalytics)

// GoogleApiWrapper({
//     apiKey: ('AIzaSyDXgsxWEgtVWgZdU5W4htOoQgUOOVeYK1k')
// })(MapGoogle)
